import React from 'react';
import { FolderInput, Brain, Building2, FileText } from 'lucide-react';

const STEPS = [
  {
    icon: FolderInput,
    title: 'Point at OneDrive or Dropbox',
    body:
      'Select your shared OneDrive, Dropbox, or local invoice folder. Sortio handles batches in the thousands. Customers have processed 3,000+ file backlogs in a single run.',
  },
  {
    icon: Brain,
    title: 'AI reads each invoice',
    body:
      "Sortio's AI extracts vendor name, invoice date, invoice number, amount, and project or job number from each PDF or scan. The read happens locally on your machine. In Offline mode (Ollama) or with BYOK nothing leaves your machine; by default the sort runs on our cloud and invoice contents are sent only if you enable a content-based feature.",
  },
  {
    icon: Building2,
    title: 'Routed by vendor or project',
    body:
      'Each file lands in the right vendor folder or project subfolder. Duplicate vendor folders (the classic "Aster" vs "Aster Inc" problem) get consolidated. Multi-year payroll is grouped by year and pay period.',
  },
  {
    icon: FileText,
    title: 'Renamed by content',
    body:
      "Every file is renamed to a consistent pattern: '20250412 - Aster Construction - $4,820.50 - INV-1138.pdf'. Vendor invoice retrieval at tax time becomes a one-line search instead of a half-day hunt.",
  },
];

const Workflow = () => {
  return (
    <section id="workflow" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          How it works
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Four steps from a chaotic OneDrive to vendor-organized, date-stamped, amount-tagged files.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map((step, i) => {
          const Icon = step.icon;
          return (
            <div
              key={i}
              className="relative bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6 flex flex-col"
            >
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 rounded-full bg-sortio-primary/15 border border-sortio-primary/30 flex items-center justify-center mr-3">
                  <Icon className="text-sortio-primary" size={18} />
                </div>
                <span className="text-xs font-medium uppercase tracking-wider text-apple-400">
                  Step {i + 1}
                </span>
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-2">{step.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{step.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Workflow;
